export enum UserGuideImageLayout {
  SECTION = "section",
  COMPACT = "compact"
}
